// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tEY8","importantInfo":"styles_importantInfo__1Ustt"};